export default __webpack_public_path__ + "static/media/zap-light.8fb87b93.svg";